import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = { class: "columns is-mobile" };
const _hoisted_2 = { class: "column" };
const _hoisted_3 = /*#__PURE__*/ _createElementVNode("i", { class: "fas fa-clock mr-2" }, null, -1);
const _hoisted_4 = { key: 0 };
const _hoisted_5 = { key: 1 };
const _hoisted_6 = { key: 2 };
import { formatDateTime, formatTimeDifference } from "@/core/utils";
import { requestStatusLabels } from "@/features/applications/model";
export default /*#__PURE__*/ _defineComponent({
    __name: 'ApplicationStatusHistory',
    props: {
        statusHistory: {}
    },
    setup(__props) {
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("ul", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.statusHistory, (statusChange, idx) => {
                            return (_openBlock(), _createElementBlock("li", { key: idx }, [
                                _hoisted_3,
                                (idx == 0)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_4, "Created with status "))
                                    : (_openBlock(), _createElementBlock("span", _hoisted_5, "Status changed to ")),
                                _createElementVNode("strong", null, _toDisplayString(_unref(requestStatusLabels)[statusChange.toStatus]), 1),
                                _createTextVNode(" at " + _toDisplayString(_unref(formatDateTime)(statusChange.occurredAt)) + " ", 1),
                                (idx < _ctx.statusHistory.length - 1)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_6, " (remained in this status for " + _toDisplayString(_unref(formatTimeDifference)(_ctx.statusHistory[idx].occurredAt, _ctx.statusHistory[idx + 1].occurredAt)) + ")", 1))
                                    : _createCommentVNode("", true)
                            ]));
                        }), 128))
                    ])
                ])
            ]));
        };
    }
});
